module.exports = __webpack_public_path__ + "img/TruckOn.f22401f6.png";